import { mergeCreatedCategoryIntoCatalog } from './categoryCatalog';

export const normalizePickerSectionOption = (option, sectionName) => ({
  ...option,
  id: String(option?.id ?? ''),
  name: option?.name || option?.label || '',
  parentName: option?.parentName || sectionName,
});

const hasMatchingId = (items, id) => items.some((item) => String(item?.id) === String(id));

export const mergeOptimisticCategories = (baseCategories = [], optimisticCategories = []) => {
  if (!Array.isArray(optimisticCategories) || optimisticCategories.length === 0) {
    return Array.isArray(baseCategories) ? baseCategories : [];
  }

  return optimisticCategories.reduce(
    (catalog, createdCategory) => mergeCreatedCategoryIntoCatalog(catalog, createdCategory),
    Array.isArray(baseCategories) ? baseCategories : []
  );
};

export const mergeOptimisticSections = ({
  baseSections = [],
  optimisticCategories = [],
  categoryCatalog = [],
}) => {
  if (!Array.isArray(baseSections) || baseSections.length === 0 || optimisticCategories.length === 0) {
    return baseSections;
  }

  const mergedSections = baseSections.map((section) => ({
    ...section,
    options: (Array.isArray(section.options) ? section.options : []).map((option) =>
      normalizePickerSectionOption(option, section.name)
    ),
  }));

  optimisticCategories.forEach((category) => {
    if (!category?.id) return;

    const parent = category.parent_id != null
      ? categoryCatalog.find((candidate) => Number(candidate?.id) === Number(category.parent_id))
      : null;
    const parentName = category.parentName || parent?.name || '';
    if (!parentName) return;

    const option = normalizePickerSectionOption({
      id: category.id,
      name: category.name || category.label || '',
      parentName,
    }, parentName);

    const sectionIndex = mergedSections.findIndex((section) => section.name === parentName);
    if (sectionIndex === -1) {
      mergedSections.push({
        id: `section:optimistic:${category.parent_id ?? parentName}`,
        name: parentName,
        options: [option],
      });
      return;
    }

    if (!hasMatchingId(mergedSections[sectionIndex].options, option.id)) {
      mergedSections[sectionIndex] = {
        ...mergedSections[sectionIndex],
        options: [...mergedSections[sectionIndex].options, option],
      };
    }
  });

  return mergedSections;
};

export const buildCreatedCategorySelectionState = ({
  categories = [],
  sections = null,
  createdCategory = null,
}) => {
  if (!createdCategory?.id) {
    return {
      createdCategory: null,
      categoryCatalog: Array.isArray(categories) ? categories : [],
      sections,
    };
  }

  const categoryCatalog = mergeOptimisticCategories(categories, [createdCategory]);
  return {
    createdCategory,
    categoryCatalog,
    sections: Array.isArray(sections)
      ? mergeOptimisticSections({
          baseSections: sections,
          optimisticCategories: [createdCategory],
          categoryCatalog,
        })
      : sections,
  };
};
